import styled from '@emotion/styled';
import { ProgressSpinner } from 'primereact/progressspinner';

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 480px;
    padding: 8px 0;
`;

export const FieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const Label = styled.label`
    display: flex;
    align-items: center;
    gap: 6px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 11px;
    font-weight: 600;
    color: #6b7280;
`;

// Undoes Label's uppercase/letter-spacing so the link reads as a normal sentence.
export const FormatHelpLink = styled.a`
    text-transform: none;
    letter-spacing: normal;
    font-weight: 400;
    color: #0891b2;
`;

export const PreviewSpinner = styled(ProgressSpinner)`
    width: 12px;
    height: 12px;
    margin: 0;
`;

export const PlaceholderList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
`;

// auto-fit stacks the two columns once the dialog is too narrow (80vw cap) to give each 320px.
export const BodyPreviewRow = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 16px;
`;

export const PreviewColumn = styled(FieldWrapper)`
    min-width: 0;
`;

export const PreviewBox = styled.div`
    flex: 1;
    min-height: 146px;
    overflow-wrap: anywhere;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 10px 12px;
    font-size: 14px;
    line-height: 1.5;

    p,
    ul,
    ol {
        margin: 0 0 8px;
    }

    ul,
    ol {
        padding-left: 20px;
    }

    li {
        margin: 0;
    }

    p:last-child,
    ul:last-child,
    ol:last-child {
        margin-bottom: 0;
    }
`;

export const PreviewEmpty = styled.div`
    color: #9ca3af;
    font-size: 14px;
`;

export const ErrorText = styled.div`
    color: #dc2626;
    font-size: 12px;
`;

export const FormActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
`;
